import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-applicant',
  templateUrl: './applicant.component.html'
})
export class ApplicantComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  @Input() solicitante: any;

  public form: FormGroup;

  constructor(private fb: FormBuilder) { }

  

  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      ss: ['', [Validators.required]],
      licence: ['', [Validators.required]],
      birthDate: ['', [Validators.required]],
      civilStatus: ['', [Validators.required]],
      dependientes: ['', [Validators.required]],
      isCodeudor: ['', [Validators.required]],
      housePayment: ['', [Validators.required]],
      yearsInHouse: ['', [Validators.required]],
    });
    this.formReady.emit(this.form);

    this.form.patchValue(this.solicitante);
  }

  addChildForm(name: string, group: FormGroup) {
    this.form.addControl(name, group);
  }

}
